<template>
  <div class="flex">
    <a href="javascript:;" @click="downloadTemplate" class="m-r-10">
      <i class="el-icon-download"/>
      {{ importDesc }}
    </a>
    <uploader
        ref="uploader"
        :target="target"
        @success="handleImportSuccess"
        @error="handleImportError"
        accept=".xlsx,.xls,.csv"
    >
      <a href="javascript:;">
        <i class="el-icon-upload"/>
        {{ exportDesc }}
      </a>
    </uploader>
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    template: {
      type: String,
      default: undefined
    },
    target: {
      type: String,
      default: undefined
    },
    importDesc: {
      type: String,
      default: '下载模板'
    },
    exportDesc: {
      type: String,
      default: '导入'
    }
  },
  methods: {
    async downloadTemplate() {
      if (!this.template) return this.$message.warning('请指定target')
      this.$linkHelper.redirect(this.template)
    },
    handleImportSuccess(res) {
      if (res.count > 0) {
        this.$message.success(`成功导入了${res.count}条数据`)
      } else {
        this.$message.success('导入完成')
      }
      this.$refs.uploader.clearFiles()
      this.$emit('success')
    },
    handleImportError(error) {
      this.$message.error('导入失败了：' + error.message)
    },
  }
}
</script>

<style scoped>

</style>